import React from "react";
import styled from "styled-components";
import PropTypes from "prop-types";
import { Col, FormGroup, Label, Row } from "reactstrap";
import { AvField } from "availity-reactstrap-validation";
import CustomSelect from "../../../../../components/Common/CustomSelect";

const EditPlanItems = ({ num, keys, onDelete, filter_data, isFormSubmit }) => {
  const [account, setAccount] = React.useState();
  const [offer, setOffer] = React.useState();

  return (
    <StyledRow className="justify-content-between fade-in-custom-animate ">
      <Col xl={3} className="mt-1 mb-1">
        <FormGroup className="">
          <Label htmlFor="validationCustom02">Project Manager:</Label>
          <CustomSelect
            name={`account_manager|${keys}`}
            options={filter_data.account_managers}
            placeholder="Select manager..."
            onChange={setAccount}
            classNamePrefix="select2-selection"
            errorMessage="Project manager field is required!"
            required
            isFormSubmit={isFormSubmit}
          />
        </FormGroup>
      </Col>

      <Col xl={3} className="mt-1 mb-1">
        <div className="">
          <Label>Group name:</Label>
          <AvField
            name={`name|${keys}`}
            type="text"
            errorMessage="This value is required."
            placeholder="Group name..."
            validate={{
              required: {
                value: true,
                errorMessage: "This value is required",
              },
            }}
          />
        </div>
      </Col>
      <Col xl={3} className="mt-1 mb-1">
        <div className="">
          <Label>Plan:</Label>
          <AvField
            name={`plan|${keys}`}
            type="number"
            errorMessage="This value is required."
            placeholder="Planned sum..."
            validate={{
              required: {
                value: true,
                errorMessage: "This value is required",
              },
              min: {
                value: 0,
                errorMessage: "This value cannot be negative",
              },
            }}
          />
        </div>
      </Col>
      <Col xl={3} className="mt-1 mb-1">
        <div className="">
          <Label>Corrected plan:</Label>
          <AvField
            name={`corrected_plan|${keys}`}
            type="number"
            errorMessage="This value is required."
            placeholder="Corrected plan..."
            validate={{
              required: {
                value: true,
                errorMessage: "This value is required",
              },
              min: {
                value: 0,
                errorMessage: "This value cannot be negative",
              },
            }}
          />
        </div>
      </Col>
      <Col xl={num === 1 ? "12" : "11"} className="mt-1 mb-1">
        <FormGroup className="">
          <Label htmlFor="validationCustom02">Offers: </Label>
          <CustomSelect
            name={`offer|${keys}`}
            options={filter_data.all_offers}
            placeholder="Select offer..."
            onChange={setOffer}
            classNamePrefix="select2-selection"
            errorMessage="Offer field is required!"
            isFormSubmit={isFormSubmit}
            isMulti
            required
          />
        </FormGroup>
      </Col>
      <Col xl={1} className="mt-1" style={{ display: num === 1 ? "none" : "" }}>
        <button
          type="button"
          className="btn btn-danger btn-sm"
          style={{ marginTop: "27px", float: "right" }}
          onClick={onDelete}
        >
          <i className="mdi mdi-trash-can d-block font-size-17" />
        </button>
      </Col>
    </StyledRow>
  );
};

const StyledRow = styled(Row)`
  margin: 0;
  margin-bottom: 10px;
  padding: 20px;
  border: 1px solid #dcdde2;
  box-sizing: border-box;
  border-radius: 3px;
`;

EditPlanItems.propTypes = {
  data: PropTypes.any,
  keys: PropTypes.string.isRequired,
  num: PropTypes.number.isRequired,
  onDelete: PropTypes.func,
  filter_data: PropTypes.object.isRequired,
  isFormSubmit: PropTypes.bool,
};

export default EditPlanItems;
